import {Dispatch} from "redux";
import axios from 'axios';
import {
  ITEM_TYPE_FAIL,
  ITEM_TYPE_LOADING,
  ITEM_TYPE_LIST,
  ITEM_TYPE_PUT,
  ITEM_TYPE_CREATE,
  ITEM_TYPE_UPDATE_PER_LABEL_VALUE,
  ITEM_TYPE_REFRESH,
  ItemTypeDispatchTypes,
  MASS_ITEM_STATUS,
  MASS_ITEM_LIST,
  RETRY_MASS_ITEM_PROCESS_SUCCESS} from "./ItemTypeActionsTypes";
import { getProjectConfig } from "../../getProjectConfig";

const apiURL: string | undefined = process.env.REACT_APP_API_URL;
const token: string | undefined = localStorage.token;

/**
 * Gets all item categories from BE.
 *
 */
export const getItemTypes = (qParams?: object) => async (dispatch: Dispatch<ItemTypeDispatchTypes>) => {

  if (apiURL !== '' && token !== '') {
    try {
      dispatch({
        type: ITEM_TYPE_LOADING,
        payload: 'ITEM_TYPE_LIST'
      })

      const headers: object = {
        ContentType: 'application/json',
        Authorization: 'Bearer ' + token
      }

      const requestPath = !token ? `${apiURL}/guest/getAllItemType` : `${apiURL}/user/getAllItemType`;

      const res = await axios.get(requestPath, {
        params: qParams || { size: getProjectConfig().UNLIMITED_PAGES_SIZE },
        headers: headers
       });

       if (res.status === 200) {
          const queryData = res.data.data.content;
          const categories:any = [];
         

        for(var i = 0; i < queryData.length; i++) {
          const category = queryData[i];
        
          categories.push({
            id: category.id,
            taxPercentage: category.taxPercentage,
            name: category.name,
            image_url: category.image_url,
            description: category.description,
            isDeleted: category.isDeleted,
            isPublished: category.isPublished
          });
        }
  
        const data:any = {
          first: res.data.data.first,
          last: res.data.data.last,
          number: res.data.data.number,
          size: res.data.data.size,
          totalPages: res.data.data.totalPages,
          categories: categories
        };

        dispatch({
          type: ITEM_TYPE_LIST,
          payload: data
        })
       } else {
        dispatch({
          type: ITEM_TYPE_FAIL,
          payload: 'status.get-error'
        })
       }
    } catch(e) {
      dispatch({
        type: ITEM_TYPE_FAIL,
        payload: 'status.get-error'
      })
    }
  } else {
    dispatch({
      type: ITEM_TYPE_FAIL,
      payload: 'status.get-error'
    })
  }
};

/**
 * Update a item type on BE.
 * @param {any} category
 */
 export const createItemType = (category: any) => async (dispatch: Dispatch<ItemTypeDispatchTypes>) => {
  try {
    dispatch({
      type: ITEM_TYPE_LOADING,
      payload: 'CREATE_TYPE'
    })

    const bodyForm = category;

    const configPUT = {
      headers: {
        'Accept': '*/*',
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json',
      }
    };

    let requestPath = `${apiURL}/admin/registerItemType`;
  
    const res = await axios.post(requestPath, bodyForm, configPUT);
    if (res.status === 200) {
      dispatch({
        type: ITEM_TYPE_CREATE,
        payload: 'status.success-saved'
      })
    } else {
      dispatch({
        type: ITEM_TYPE_FAIL,
        payload: 'status.error-create'
      })
    }

  } catch(e) {
    dispatch({
      type: ITEM_TYPE_FAIL,
      payload: 'status.error-create'
    })
  }
};

/**
 * Update a item type on BE.
 * @param {any} category
 */
 export const updateItemType = (category: any) => async (dispatch: Dispatch<ItemTypeDispatchTypes>) => {
  try {
    dispatch({
      type: ITEM_TYPE_LOADING,
      payload: 'UPDATE_TYPE'
    })

    const bodyForm = category;

    const configPUT = {
      headers: {
        'Accept': '*/*',
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json',
      }
    };

    let requestPath = `${apiURL}/admin/updateItemType`;
  
    const res = await axios.put(requestPath, bodyForm, configPUT);
    if (res.status === 200) {
      dispatch({
        type: ITEM_TYPE_PUT,
        payload: 'status.success-saved'
      })
    } else {
      dispatch({
        type: ITEM_TYPE_FAIL,
        payload: 'status.error-update'
      })
    }

  } catch(e) {
    dispatch({
      type: ITEM_TYPE_FAIL,
      payload: 'status.error-update'
    })
  }
};

/**
 * Update in bulk all items by label id.
 * @param { string } labelValueId
 * @param { string } process
 */

export const updateItemPerLabelValue = (labelValueId: string, process: string, runDate: string | null) => async (dispatch:Dispatch<ItemTypeDispatchTypes>) => {
  if (apiURL !== '' && token !== '') {
    try {
      dispatch({
        type: ITEM_TYPE_LOADING,
        payload: 'ITEM_TYPE_UPDATE_PER_LABEL_VALUE'
      });

      const bodyForm = {
        labelValueId: labelValueId,
        process: process,
        runDate: runDate
      }
      const configPUT = {
        headers: {
          'Accept': '*/*',
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json',
        }
      };

      const addRes = await axios.put(`${apiURL}/admin/massItemProcess`, bodyForm, configPUT);
      
      if (addRes.status === 200) {
        dispatch({
          type: ITEM_TYPE_UPDATE_PER_LABEL_VALUE,
          payload: 'status.success-update'
        });
      }

    } catch(error: any) {
      if (error.response && error.response.data.status_code === 422) {
				//Showing the error message when something went wrong during the BE validation.
				dispatch({
					type: ITEM_TYPE_FAIL,
					payload: error.response.data.message,
				});
			} else {
        dispatch({
          type: ITEM_TYPE_FAIL,
          payload: 'status.error-update'
        });
      }
    }

  } else {
    dispatch({
      type: ITEM_TYPE_FAIL,
      payload: 'status.error-update'
    });
  }

}

export const getAllMassItemStatus = () => async (dispatch: Dispatch<ItemTypeDispatchTypes>) => {
  if (apiURL !== '' && token !== '') {
    try {
      dispatch({
        type: ITEM_TYPE_LOADING,
        payload: 'MASS_ITEM_STATUS'
      });

      const configGET = {
        headers: {
          'Accept': '*/*',
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json',
        }
      };

      const res = await axios.get(`${apiURL}/admin/getAllMassItemStatus`, configGET);
      
      if (res.status === 200) {
        dispatch({
          type: MASS_ITEM_STATUS,
          payload: res.data.data
        });
      }

    } catch(error: any) {
      if (error.response && error.response.data.status_code === 422) {
        //Showing the error message when something went wrong during the BE validation.
        dispatch({
          type: ITEM_TYPE_FAIL,
          payload: error.response.data.message,
        });
      } else {
        dispatch({
          type: ITEM_TYPE_FAIL,
          payload: 'status.error-update'
        });
      }
    }

  } else {
    dispatch({
      type: ITEM_TYPE_FAIL,
      payload: 'status.error-update'
    });
  }
}

export const getMassItemQueue = (qParams?: object) => async (dispatch: Dispatch<ItemTypeDispatchTypes>) => {
  if (apiURL !== '' && token !== '') {
    try {
      dispatch({
        type: ITEM_TYPE_LOADING,
        payload: 'MASS_ITEM_QUEUE'
      });

      const headers: object = {
        ContentType: 'application/json',
        Authorization: 'Bearer ' + token
      }

      const requestPath = `${apiURL}/admin/getMassItemQueue`;

      const res = await axios.get(requestPath, {
        params: qParams || { paged: false, unpaged: true },
        paramsSerializer: (params) => {
          return new URLSearchParams(params).toString(); // Serializa arrays correctamente
        },
        headers
      });

       if (res.status === 200) {
         
        dispatch({
          type: MASS_ITEM_LIST,
          payload: res.data
        })
       } else {
        dispatch({
          type: ITEM_TYPE_FAIL,
          payload: 'status.get-error'
        })
       }
    } catch(e) {
      dispatch({
        type: ITEM_TYPE_FAIL,
        payload: 'status.get-error'
      })
    }
  } else {
    dispatch({
      type: ITEM_TYPE_FAIL,
      payload: 'status.get-error'
    })
  }
}

export const retryMassItemProcess = (massItemQueueId: number, cancelProgrammedProcess: Boolean) => async (dispatch: Dispatch<ItemTypeDispatchTypes>) => {
  if (apiURL !== '' && token !== '') {
    try {
      dispatch({
        type: ITEM_TYPE_LOADING,
        payload: 'RETRY_MASS_ITEM_PROCESS_LOADING'
      });

      const bodyForm = {
        massItemQueueId: massItemQueueId,
        cancelProgrammedProcess: cancelProgrammedProcess
      };

    const configPUT = {
      headers: {
        'Accept': '*/*',
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json',
      }
    };

    const requestPath = `${apiURL}/admin/retryMassItemProcess?massItemQueueId=${massItemQueueId}`;

    const res = await axios.put(requestPath, bodyForm, configPUT);

       if (res.status === 200) {
        dispatch({
          type: RETRY_MASS_ITEM_PROCESS_SUCCESS,
          payload: res.data.data,
        });
        dispatch({
          type: ITEM_TYPE_REFRESH,
          payload: true
        })
       } else {
        dispatch({
          type: ITEM_TYPE_FAIL,
          payload: 'status.get-error'
        })
       }
    } catch(e) {
      dispatch({
        type: ITEM_TYPE_FAIL,
        payload: 'status.get-error'
      })
    }
  } else {
    dispatch({
      type: ITEM_TYPE_FAIL,
      payload: 'status.get-error'
    })
  }
}
/**
 * Update the refresh view state, when the value is true the view will refresh.
 * @param {boolean} value
 */
export const refreshItemTypeView = (value: boolean) => async (dispatch: Dispatch<ItemTypeDispatchTypes>) => {
  dispatch({
    type: ITEM_TYPE_REFRESH,
    payload: value
  })
}


